var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import "pixi.js";
import { fromEvent, merge } from "rxjs";
import { filter, map, switchMap, takeUntil } from "rxjs/operators";
var Point = PIXI.Point;
import { IdButtonPointer } from "./IdButtonPointer";
var defaultOptions = {
    clickErrorRadiusSqrd: 16,
};
var EventsCanvas = /** @class */ (function () {
    function EventsCanvas() {
        var _this = this;
        this.setup = function (interactionManager, options) {
            if (options === void 0) { options = defaultOptions; }
            var opts = __assign({}, defaultOptions, options);
            _this.supportsPointerEvents = interactionManager.supportsPointerEvents;
            _this._mousedown$ = _this.createMouseDown$(interactionManager);
            _this._mouseup$ = _this.createMouseUp$(interactionManager);
            _this._mousemove$ = _this.createMouseMove$(interactionManager);
            _this._mouseover$ = _this.createMouseOver$(interactionManager);
            _this._mouseout$ = _this.createMouseOut$(interactionManager);
            _this._click$ = _this._createClick$(_this._mousedown$, _this.mouseup$, opts.clickErrorRadiusSqrd);
            _this._drag$ = _this.createDrag$(interactionManager);
        };
        this.createMouseDown$ = function (target) {
            return merge(_this.supportsPointerEvents
                ? fromEvent(target, "pointerdown").pipe(filter(_this.onlyButton(IdButtonPointer.Main)))
                : fromEvent(target, "mousedown"), fromEvent(target, "touchstart"));
        };
        this.createMouseUp$ = function (target) {
            return merge(_this.supportsPointerEvents
                ? fromEvent(target, "pointerup").pipe(filter(_this.onlyButton(IdButtonPointer.Main)))
                : fromEvent(target, "mouseup"), fromEvent(target, "touchend"));
        };
        this.createMouseMove$ = function (target) {
            return merge(_this.supportsPointerEvents
                ? fromEvent(target, "pointermove")
                : fromEvent(target, "mousemove"), fromEvent(target, "touchmove"));
        };
        this.createMouseOver$ = function (target) {
            return merge(_this.supportsPointerEvents
                ? fromEvent(target, "pointerover")
                : fromEvent(target, "mouseover"), fromEvent(target, "touchstart"));
        };
        this.createMouseOut$ = function (target) {
            return merge(_this.supportsPointerEvents
                ? fromEvent(target, "pointerout")
                : fromEvent(target, "mouseout"), fromEvent(target, "touchstart").pipe(filter(function (event) { return event.target !== target; })));
        };
        this.createDrag$ = function (target) {
            return _this.createMouseDown$(target).pipe(switchMap(function (down) {
                var _a = down.data.global, x = _a.x, y = _a.y;
                var downPoint = new Point(x, y);
                var timestamp = performance.now();
                return _this._mousemove$.pipe(takeUntil(_this._mouseup$), map(function (move) {
                    return ({
                        deltaTime: performance.now() - timestamp,
                        distance: _this.distance(downPoint, move.data.global),
                        from: downPoint,
                        target: move.target,
                        to: new Point(move.data.global.x, move.data.global.y),
                    });
                }));
            }));
        };
        this.createClick$ = function (target, clickErrorRadiusSqrd) {
            if (clickErrorRadiusSqrd === void 0) { clickErrorRadiusSqrd = defaultOptions.clickErrorRadiusSqrd; }
            return _this._createClick$(_this.createMouseDown$(target), _this.createMouseUp$(target), clickErrorRadiusSqrd);
        };
        this._createClick$ = function (down$, up$, clickErrorRadiusSqrd) {
            return down$.pipe(switchMap(function (down) {
                var _a = down.data.global, x = _a.x, y = _a.y;
                var target = down.target;
                return up$.pipe(filter(function (up) {
                    return target === up.target &&
                        _this.distanceLessThan(new Point(x, y), up.data.global, clickErrorRadiusSqrd);
                }));
            }));
        };
        this.distanceLessThan = function (a, b, value) { return _this.distance(a, b) < value; };
        this.onlyButton = function (button) { return function (interaction) {
            return interaction.data.button === button;
        }; };
        this.distance = function (a, b) { return Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2); };
    }
    Object.defineProperty(EventsCanvas.prototype, "mousedown$", {
        get: function () {
            return this._mousedown$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "mouseup$", {
        get: function () {
            return this._mouseup$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "mousemove$", {
        get: function () {
            return this._mousemove$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "mouseover$", {
        get: function () {
            return this._mouseover$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "mouseout$", {
        get: function () {
            return this._mouseout$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "click$", {
        get: function () {
            return this._click$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventsCanvas.prototype, "drag$", {
        get: function () {
            return this._drag$;
        },
        enumerable: true,
        configurable: true
    });
    return EventsCanvas;
}());
export var eventsCanvas = new EventsCanvas();



//////////////////
// WEBPACK FOOTER
// ./src/events/eventsCanvas.ts
// module id = 244
// module chunks = 3